module.exports = __webpack_public_path__ + "media/Teni-Billionaire.9fc64cc6.mp3";